import { DialogModule } from 'primeng/dialog';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AvatarModule } from '@jms/ui/ui.avatar';
import { EmptyMessageModule } from '@jms/ui/ui.empty.message';
import { LuxonCalendarModule } from '@workbuddy/ui/fields/luxon.calendar';
import { EntityItemModule } from '@jms/ui/ui.standalone.pickers';

import { TimeSimplePipe } from '@jms/utils/util.pipes';
import { AppointmentListSidebarComponent } from './components';
import { AppointmentStatusColorDirective } from './directives';
import { UnAllocatedPipe } from './pipes';
import { BadgeComponent } from '@workbuddy/ui/components/badge';
import { ButtonComponent } from '@workbuddy/ui/components/button';

const components = [
  AppointmentListSidebarComponent,
];


@NgModule({
  declarations: [
    ...components,
    AppointmentStatusColorDirective,
    UnAllocatedPipe,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    EmptyMessageModule,
    EntityItemModule,
    DialogModule,
    AvatarModule,
    LuxonCalendarModule,
    TimeSimplePipe,
    BadgeComponent,
    ButtonComponent,
  ],
  exports: [
    ...components
  ],
  providers: []
})
export class AppointmentViewModule { }
